/* eslint-disable import/no-cycle */
import { axios } from '../axios';

const API_URL = `${process.env.VUE_APP_API_URL}/v1`;

const AuthService = {
  login: (username, password, cadence) => axios.post(`${API_URL}/user/login`, { username, password, cadence }),
  logout: () => axios.post(`${API_URL}/user/logout`),
  cadences: () => axios.get(`${API_URL}/shared/cadence`),
};

export { AuthService };
